<div id="location-select" *ngIf="showLocationSelector" class='d-flex align-items-center'>
    <div class="locationIcon" [ngStyle]="{'margin-right': '15px'}">
        <img [src]="'../../../../assets/icons/'+baseSiteId+'/location.svg'" alt="location_icon">
    </div>
    <div class="locationDetails">
        <div class="selected-loc" [ngClass]="{'selected-loc-underlined':getTitle() == 'Select a location'}" (click)="showChangeOption && getTitle() == 'Select a location' ? 
            openModal(content) : $event.preventDefault()">
            {{getTitle()}}
        </div>
        <div (click)="openModal(content)" *ngIf="showChangeOption && getTitle() != 'Select a location'">Change
            location
        </div>
    </div>
</div>

<!-- modal content -->
<ng-template #content let-modal>
    <div class="modal-header">
        <h3 class="modal-title">Select location</h3>
        <button class="btn-close" *ngIf="!hideCloseBtn"
            [ngStyle]="{'background-image': 'url(../../../../assets/icons/'+baseSiteId+'/close.svg)'}"
            (click)="searchKeyword = null;noResults = false;modal.dismiss();hideReturnText=false"></button>
    </div>
    <div class="modal-body">
        <div *ngIf="hideCloseBtn && !hideReturnText" class="returns-heading">
            <h4>To initiate your return, please select a location:</h4>
        </div>
        <div [ngStyle]="{'position': 'relative'}">
            <input type="text"
                [ngStyle]="{'background-image': 'url(../../../../assets/icons/'+baseSiteId+'/search_new.svg)'}"
                name="searchbox" #searchbox placeholder="Filter by location name, city, zip code"
                [(ngModel)]="searchKeyword" (input)="searchLoc(searchbox.value)">

            <img src="../../../../assets/icons/close.svg" *ngIf="searchbox.value" alt="close-icon"
                (click)="searchbox.value = '';searchKeyword = null;searchLoc('')">
        </div>
        <hr [ngStyle]="{'margin': '10px 0'}" *ngIf="isMultiSelectionPossible || showGovFilter">
        <div class="error" *ngIf="showError">Please select one government or one or more non-government locations</div>
        <div class="loc-results">
            <div class="selection-btns d-flex flex-row" *ngIf="!noResults"
                [ngStyle]="{'border-top': showError ? '1px solid #e5e9ec' : 'none'}">
                <div *ngIf="isMultiSelectionPossible" class="loc loc-group  d-flex flex-row align-items-end">

                    <input type="checkbox" id="checkBox" name="all" (change)="filterLocations($event,'selectAll')"
                        class="col-2">
                    <span class="checkmark"></span>
                    <label>Select all</label>

                </div>
                <div *ngIf="showGovFilter" class="loc loc-group  d-flex flex-row align-items-end">
                    <input type="checkbox" id="checkBox" name="gov" (change)="filterLocations($event,'gov')"
                        class="col-2">
                    <span class="checkmark"></span>
                    <label>Government location</label>
                </div>
            </div>
            <label class="no-results" *ngIf="!testxxx?.length || noResults">No results</label>
            <!-- new implementation -->
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [ngStyle]="{'display': node.display}">
                    <div class="loc d-flex flex-row align-items-start w-100"
                        *ngIf="!showOnlyGovLocs || (showOnlyGovLocs && node.govLocation)">
                        <input type="checkbox" id="checkBox" name="assignedLocation" class="col-2"
                            [checked]="node.checked" (change)="filterLocations($event, 'individualLoc', node)">
                        <span class="checkmark"></span>
                        <label class="col-10" [ngStyle]="{'font': '12px/17px LexendDeca-Regular'}">
                            <span>{{node.facilityName}}<span
                                    *ngIf="node.govLocation">-GOV</span>&nbsp;({{node.accountNumber}})&nbsp;{{node.formattedAddress}},&nbsp;{{node.phoneNo}}</span>
                        </label>
                    </div>
                </mat-tree-node>

                <!-- This is the tree node template for expandable nodes -->
                <mat-tree-node *matTreeNodeDef="let node;when:hasChild" matTreeNodePadding
                    [ngStyle]="{'display': node.display}">

                    <div class="loc d-flex flex-row align-items-start w-100">
                        <input type="checkbox" id="checkBox" name="assignedLocation" class="col-2"
                            *ngIf="isMultiSelectionPossible" [checked]="node.checked"
                            (change)="selectChilds($event,node)">
                        <span class="checkmark" *ngIf="isMultiSelectionPossible"></span>
                        <label class="col-10" [ngStyle]="{'font': '16px/17px LexendDeca-Bold'}">
                            {{node.name}}
                        </label>
                        <!-- {{treeControl.isExpanded(node) ? 'minimize' : 'expand'}} -->
                        <img src="../../../../assets/icons/vsh/{{ (treeControl.isExpanded(node) ? 'minus-green' : 'plus-green') + '.png'}}"
                            matTreeNodeToggle alt="{{treeControl.isExpanded(node) ? 'minus' : 'plus'}}">
                    </div>
                </mat-tree-node>
            </mat-tree>

        </div>

    </div>
    <div class="modal-footer">
        <button class="btn-primary" [disabled]="checkBtnVisibility()" ngbAutofocus
            (click)="updateLocation()">Done</button>
    </div>
</ng-template>